import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { PacienteDTO } from '../../dtos/paciente-dto';
import { TipoMarcacaoEnum } from '../../enums/tipo-marcacao-enum';
import { Paciente } from '../../paciente/paciente';
import { PlanoSaude } from '../../plano-saude/plano-saude';
import { PlanoSaudeService } from '../../plano-saude/plano-saude.service';
import { UsuarioService } from '../../usuario/usuario.service';
import { MarcacaoComponent } from '../marcacao.component';
import { MarcacaoDTO } from '../../dtos/marcacao-dto';

@Component({
  selector: 'app-selecao-paciente',
  templateUrl: './selecao-paciente.component.html',
  styleUrls: ['./selecao-paciente.component.css'],
})
export class SelecaoPacienteComponent
  extends MarcacaoComponent
  implements OnInit, OnDestroy
{
  agendamentos: MarcacaoDTO[] = [];

  listaDePacienteESeusDependentes: Array<Paciente> = [];

  listaDePlanosDeSaude: Array<PlanoSaude> = [];

  formularioDeSelecaoDePaciente: FormGroup;

  observacaoPlanoSaude: string = '';

  testeUsuarioLogadoSubscription: Subscription | null = null;

  constructor(
    private planoSaudeService: PlanoSaudeService,
    router: Router,
    private usuarioService: UsuarioService,
    private formBuilder: FormBuilder
  ) {
    super(router);

    this.formularioDeSelecaoDePaciente = this.formBuilder.group({
      pacienteOuDepentende: ['', [Validators.required]],
      planoSaude: ['', [Validators.required]],
      portadorDeNecessidadeEspecial: [''],
      observacao: [''],
    });
  }

  ngOnInit(): void {
    this.configurarTitulo(this.marcacaoConsulta.tipoMarcacao==TipoMarcacaoEnum.TIPO_MARCACAO_EXAME ?'(Etapa 2 de 5)': '(Etapa 1 de 4)', this.marcacaoConsulta.tipoMarcacao);

    this.validarCadastroPaciente();

    this.configurarListaDePacienteESeusDependentes();

    this.configurarListaDePlanosDeSaude();

    this.reloadData();
  }

  reloadData() {
    if (history.state.agendamentos) {
      this.agendamentos = history.state.agendamentos;
    } else {
      this.agendamentos = [];
    }
  }

  buscarUltimoAgendamentoDoPaciente(idPaciente: number): MarcacaoDTO | null {
    let doPaciente = this.agendamentos.filter(
      (a) => a.idPaciente === idPaciente
    );

    if (!doPaciente.length) doPaciente = this.agendamentos;

    return doPaciente.sort((a, b) => {
      const timeA = this.getTimestampMarcacao(a);
      const timeB = this.getTimestampMarcacao(b);

      return timeB - timeA;
    })[0];
  }

  private getTimestampMarcacao(m: MarcacaoDTO): number {
    if (!m.dataMarcacao) {
      return -Infinity; // sempre vai para o final
    }

    const data = new Date(m.dataMarcacao);

    if (m.horaAtendimento) {
      const [hora, minuto] = m.horaAtendimento.split(':').map(Number);

      if (!isNaN(hora) && !isNaN(minuto)) {
        data.setHours(hora, minuto, 0, 0);
      }
    } else {
      // sem hora → considera início do dia
      data.setHours(0, 0, 0, 0);
    }

    return data.getTime();
  }

  onChangePacienteSelecionado(): void {
    const paciente =
      this.formularioDeSelecaoDePaciente.value.pacienteOuDepentende;

    if (!paciente) return;

    // limpa plano anterior
    this.formularioDeSelecaoDePaciente.get('planoSaude')?.reset();
    this.observacaoPlanoSaude = '';

    const ultimo = this.buscarUltimoAgendamentoDoPaciente(paciente.id);

    if (ultimo?.idPlanoSaude) {
      const plano = this.listaDePlanosDeSaude.find(
        (p) => p.id === ultimo.idPlanoSaude
      );

      if (plano) {
        this.formularioDeSelecaoDePaciente.get('planoSaude')?.setValue(plano);

        // ATUALIZA OBSERVAÇÃO (sem MatSelectChange)
        if (
          this.marcacaoConsulta.tipoMarcacao ===
          TipoMarcacaoEnum.TIPO_MARCACAO_CONSULTA
        ) {
          this.observacaoPlanoSaude = plano.observacaoConsulta;
        } else if (
          this.marcacaoConsulta.tipoMarcacao ===
          TipoMarcacaoEnum.TIPO_MARCACAO_EXAME
        ) {
          this.observacaoPlanoSaude = plano.observacao;
        }
      }
    }
  }

  configurarListaDePacienteESeusDependentes(): void {
    this.listaDePacienteESeusDependentes = [];

    if (this.marcacaoConsulta && this.marcacaoConsulta.paciente) {
      this.listaDePacienteESeusDependentes.push(this.marcacaoConsulta.paciente);

      for (let dependente of this.marcacaoConsulta.paciente.dependentes) {
        this.listaDePacienteESeusDependentes.push(dependente);
      }
    }
  }

  configurarListaDePlanosDeSaude(): void {
    if (this.usuarioLogado && this.usuarioLogado.username) {
      this.planoSaudeService
        .listarPlanoSaudeFiltroInativoOuInterno(false, true)
        .subscribe(
          (data) => {
            // console.log(data)
            this.listaDePlanosDeSaude = data;
          },
          (error) => {
            this.listaDePlanosDeSaude = [];
          }
        );
    } else {
      this.planoSaudeService
        .listarPlanoSaudeFiltroInativoOuInterno(false, false)
        .subscribe(
          (data) => {
            // console.log(data)
            this.listaDePlanosDeSaude = data;
          },
          (error) => {
            this.listaDePlanosDeSaude = [];
          }
        );
    }
  }

  onSubmit() {
    this.proximaTela();
  }

  salvarSelecaoPacienteEContinuarMarcacao(): void {
    let pacienteSelecionado: PacienteDTO = new PacienteDTO();
    pacienteSelecionado.id =
      this.formularioDeSelecaoDePaciente.value.pacienteOuDepentende.id;
    pacienteSelecionado.dataNascimento =
      this.formularioDeSelecaoDePaciente.value.pacienteOuDepentende.dataNascimento;

    this.marcacaoConsulta.pacienteSelecionado = pacienteSelecionado;
    // console.log(this.marcacaoConsulta.pacienteSelecionado);

    this.marcacaoConsulta.planoSaude =
      this.formularioDeSelecaoDePaciente.value.planoSaude;
    // console.log(this.marcacaoConsulta.planoSaude);

    if (
      this.formularioDeSelecaoDePaciente.value.portadorDeNecessidadeEspecial
    ) {
      this.marcacaoConsulta.portadorNecessidade = true;
    } else {
      this.marcacaoConsulta.portadorNecessidade = false;
    }
    // console.log(this.marcacaoConsulta.portadorNecessidade);

    if (
      this.marcacaoConsulta.tipoMarcacao ==
      TipoMarcacaoEnum.TIPO_MARCACAO_CONSULTA
    ) {
      this.router.navigate(['/marcacaoConsulta/selecionarConsulta'], {
        state: { marcacaoConsulta: this.marcacaoConsulta },
      });
    } else if (
      this.marcacaoConsulta.tipoMarcacao == TipoMarcacaoEnum.TIPO_MARCACAO_EXAME
    ) {
      this.router.navigate(['/marcacaoConsulta/selecionarExame'], {
        state: { marcacaoConsulta: this.marcacaoConsulta },
      });
    }
  }

  telaAnterior(): void {
    this.router.navigate(['/marcacaoConsulta/cadastrarPaciente'], {
      state: {
        tipoMarcacao: this.marcacaoConsulta.tipoMarcacao,
      },
    });
  }

  proximaTela(): void {
    this.salvarSelecaoPacienteEContinuarMarcacao();
  }

  onChangePlanoSaude(event: MatSelectChange): void {
    this.observacaoPlanoSaude = '';

    if (event.value) {
      if (event.value.interno && event.value.interno === true) {
        this.testeUsuarioLogadoSubscription = this.usuarioService
          .testeUsuarioLogado()
          .subscribe(
            (data) => {
              // console.log(data)

              this.configOnChangePlanoSaude(event);
            },
            (error) => {
              console.log(error);
            }
          );
      } else {
        this.configOnChangePlanoSaude(event);
      }
    }
  }

  configOnChangePlanoSaude(event: MatSelectChange): void {
    if (
      this.marcacaoConsulta.tipoMarcacao ==
      TipoMarcacaoEnum.TIPO_MARCACAO_CONSULTA
    ) {
      this.observacaoPlanoSaude = event.value.observacaoConsulta;
    } else if (
      this.marcacaoConsulta.tipoMarcacao == TipoMarcacaoEnum.TIPO_MARCACAO_EXAME
    ) {
      this.observacaoPlanoSaude = event.value.observacao;
    }
  }

  getPlanoOuFilial(includeArtigo: boolean): string {
    let retorno: string = '';

    if (environment.appAlias === 'MARQUE_EXAMES') {
      retorno = includeArtigo ? 'a Unidade' : 'Unidade';
    } else {
      retorno = includeArtigo ? 'o Plano de Saúde' : 'Plano de Saúde';
    }

    return retorno;
  }

  ngOnDestroy() {
    this.unsubscribeItems();
  }

  unsubscribeItems() {
    this.testeUsuarioLogadoSubscription?.unsubscribe();
  }
}
